export enum ProjectTypeEnum {
	TEMPLATE = 'template'
}
